import { Pipe, PipeTransform } from '@angular/core';
import { digger } from '@cbre/digger';
import { ReportRecord } from '../../models/report.model';

@Pipe({
  name: 'dataViewRoute',
  standalone: false,
})
export class DataViewRoutePipe implements PipeTransform {
  transform(record: ReportRecord, entity: string): any[] {
    const recordId = digger(record, 'data.entity.id');
    return ['/records', entity, recordId, 'details'];
  }
}
